const _excluded = ["error", "hasNext", "hasPrevious", "indexQuery", "list", "loading", "selected"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import entityReducerFactory from './factories/entityReducerFactory';
import applyReducer, { reduceReducers } from './applyReducer';
import summaryFilterOptionsConstants from '../constants/summaryFilterOptionsConstants';
const entityReducer = entityReducerFactory('summaryFilterOptions');
const initState = {
  currentSummary: null,
  currentFilter: '',
  initialIndexQuery: {
    paging: {
      current: 0,
      size: summaryFilterOptionsConstants.PAGING_SIZE
    },
    filters: {},
    sortDirection: null,
    sortAttribute: null,
    initialized: false,
    pendingFilters: null
  }
};

/**
 *  Avoid repeated serverIndex calls by setting state[currentSummary][currentFilter].loading
 */
const index = state => {
  const {
    currentSummary,
    currentFilter
  } = state;

  // Ensure that the state structure exists for the currentSummary and currentFilter
  let summaryFilterOptionState = {
    loading: true
  };
  if (state[currentSummary] && state[currentSummary][currentFilter]) {
    summaryFilterOptionState = _objectSpread(_objectSpread({}, state[currentSummary][currentFilter]), {}, {
      loading: true
    });
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    [currentSummary]: _objectSpread(_objectSpread({}, state[currentSummary]), {}, {
      [currentFilter]: _objectSpread({}, summaryFilterOptionState)
    })
  });
};

/**
 *  On failure move the error to the filter's state
 */
const indexFail = state => {
  const {
    currentSummary,
    currentFilter
  } = state;

  // Ensure the nested structure exists
  const summaryState = state[currentSummary] || {};
  const filterState = summaryState[currentFilter] || {};

  // Update the state with loading and error at the nested level
  const updatedState = _objectSpread(_objectSpread({}, state), {}, {
    [currentSummary]: _objectSpread(_objectSpread({}, summaryState), {}, {
      [currentFilter]: _objectSpread(_objectSpread({}, filterState), {}, {
        loading: false,
        error: {
          message: 'failed fetching index'
        }
      })
    })
  });

  // Optionally remove the top-level loading and error if they should not exist
  delete updatedState.error;
  delete updatedState.loading;
  return updatedState;
};

/**
 *  Store index data in summary-specific data objects to allow multiple simultaneous summaries
 *  without reloading. entityActionFactory puts all requests in the top-level state, move this
 *  to state[currentSummary][currentFilter]
 */
const indexSuccess = state => {
  var _state$currentSummary, _indexQuery$paging;
  const {
    currentSummary,
    currentFilter,
    list: newData = [],
    indexQuery
  } = state;
  const existingData = (state === null || state === void 0 || (_state$currentSummary = state[currentSummary]) === null || _state$currentSummary === void 0 || (_state$currentSummary = _state$currentSummary[currentFilter]) === null || _state$currentSummary === void 0 ? void 0 : _state$currentSummary.list) || [];
  const existingIDs = new Set(existingData.map(e => e.id));
  const updatedList = [...existingData, ...newData.filter(nd => !existingIDs.has(nd.id))];

  // Sort the updatedList using a natural sort
  updatedList.sort((a, b) => {
    const nameA = a.name || '';
    const nameB = b.name || '';
    return nameA.localeCompare(nameB, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  });
  const currentPage = (indexQuery === null || indexQuery === void 0 || (_indexQuery$paging = indexQuery.paging) === null || _indexQuery$paging === void 0 ? void 0 : _indexQuery$paging.current) || 0;
  const hasNext = newData.length > 1;
  const hasPrevious = currentPage > 0;
  const initialIndexQuery = state.initialIndexQuery || initState.initialIndexQuery;
  const updatedFilterState = _objectSpread(_objectSpread({}, state[currentSummary][currentFilter]), {}, {
    list: updatedList,
    loading: false,
    hasNext,
    hasPrevious,
    indexQuery: indexQuery || initialIndexQuery,
    initialIndexQuery,
    error: null,
    selected: state.selected || []
  });
  const updatedState = _objectSpread(_objectSpread({}, state), {}, {
    initialIndexQuery,
    [currentSummary]: _objectSpread(_objectSpread({}, state[currentSummary]), {}, {
      [currentFilter]: updatedFilterState
    })
  });
  const {
      error,
      hasNext: topHasNext,
      hasPrevious: topHasPrevious,
      indexQuery: topIndexQuery,
      list,
      loading,
      selected
    } = updatedState,
    cleanedState = _objectWithoutProperties(updatedState, _excluded);
  return _objectSpread(_objectSpread({}, cleanedState), {}, {
    initialIndexQuery
  });
};
const setCurrent = (state, {
  currentSummary,
  currentFilter
}) => _objectSpread(_objectSpread({}, state), {}, {
  currentSummary,
  currentFilter
});
const reducers = {
  [summaryFilterOptionsConstants.INDEX]: reduceReducers(entityReducer.reducers[summaryFilterOptionsConstants.INDEX], index),
  [summaryFilterOptionsConstants.INDEX_FAIL]: reduceReducers(entityReducer.reducers[summaryFilterOptionsConstants.INDEX_FAIL], indexFail),
  [summaryFilterOptionsConstants.INDEX_SUCCESS]: reduceReducers(entityReducer.reducers[summaryFilterOptionsConstants.INDEX_SUCCESS], indexSuccess),
  [summaryFilterOptionsConstants.SET_CURRENT]: setCurrent
};
export default applyReducer(reducers, initState);